import { useState } from 'react';
import { Loading } from '../loading';
import { SectionCard } from '../card';
import { LeftNav } from '../nav';
import { CardDisplay, TransactionsTable } from '../billing';
import { Track } from '../track';
import { formatUSD } from '../../util';
import { useCredits, useGlobal, useTransactions, useUser } from '../../state';
import { BillingPlanCard } from './BillingPlanCard';
import { billingPlans } from './plans';

const gridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
  gap: 20,
  alignItems: 'stretch',
};

const statGridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
  gap: 20,
};

const statBodyStyle = {
  minHeight: 74,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 6,
};

const planLabel = (subscription) => {
  if (subscription == 'monthly_10') {
    return 'Monthly subscription';
  }
  return 'Pay as you go';
};

const TransactionsHistory = () => {
  const { transactions } = useTransactions();

  return (
    <SectionCard title="Transaction History">
      <TransactionsTable transactions={transactions} />
    </SectionCard>
  );
};

const BillingAccountDetails = ({ refreshTick }) => {
  const { user } = useGlobal();
  const { credits } = useCredits();
  const { remaining } = user?.billing;

  return (
    <>
      <div style={statGridStyle}>
        <SectionCard title="Remaining Credits">
          <div style={statBodyStyle}>
            <div style={{ fontSize: 28, fontWeight: 'bold' }}>
              {remaining !== undefined ? formatUSD(remaining) : <Loading />}
            </div>
          </div>
        </SectionCard>

        <SectionCard title="Current Plan">
          <div style={statBodyStyle}>
            <div style={{ fontSize: 20, fontWeight: 'bold' }}>{planLabel(user?.subscription)}</div>
          </div>
        </SectionCard>

        <SectionCard title="Payment Method">
          <div style={statBodyStyle}>
            {!user && <Loading />}
            {user?.paymentMethodId && <CardDisplay />}
            {user && !user.paymentMethodId && <div>No card on file</div>}
          </div>
        </SectionCard>
      </div>

      <TransactionsHistory key={refreshTick} />
    </>
  );
};

export const BillingPlansPage = () => {
  const { user } = useGlobal();
  const [refreshTick, setRefreshTick] = useState(0);
  const showAccountDetails = user?.level && user.level != 'free';

  return (
    <LeftNav>
      <Track name="billing/visit" />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <h2 style={{ margin: 0 }}>Billing</h2>
          <div style={{ color: '#666', lineHeight: 1.45 }}>Choose how you want to pay for FetchFox usage.</div>
        </div>

        {showAccountDetails && <BillingAccountDetails user={user} refreshTick={refreshTick} />}

        <div style={gridStyle}>
          {billingPlans.map((plan) => (
            <BillingPlanCard key={plan.id} plan={plan} onSuccess={() => setRefreshTick((tick) => tick + 1)} />
          ))}
        </div>
      </div>
    </LeftNav>
  );
};
